import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tab-button',
  templateUrl: './tab-button.component.html',
  styleUrls: ['./tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabButtonComponent {
  @Input({ required: true }) label!: string;
  @Input() isSelected = true;
  @Output() clickEvent = new EventEmitter<void>();

  get tabStyles(): [string, string][] {
    const key = `tab-${this.isSelected ? 'selected' : 'unselected'}`;
    return [
      ['type', `${key}-label`],
      ['text-color', `${key}-label`],
      ['background', key],
      ['border', key],
      ['border-radius', key],
      ['drop-shadow', key],
      ['height', 'tab'],
    ];
  }

  onClick(event: MouseEvent | TouchEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
